export const arboretumBlueprint = {
  id: "arboretum-id",
  name: "Arboretum",
  quadrants: [
    {
      id: "source",
      displayName: "Source",
      backgroundColor: "#FFFFF0",
      children: ["body", "mind", "spirit"],
      skillslots: [],
      top: "10%",
      left: "50%",
      disabled: true,
    },
    {
      id: "spirit",
      displayName: "Spirit",
      backgroundColor: "#FFD700",
      children: ["assurance", "assistance", "source"],
      skillslots: [],
      top: "30%",
      left: "75%",
      disabled: true,
    },
    {
      id: "mind",
      displayName: "Mind",
      backgroundColor: "#6495ED",
      children: ["action", "assurance", "source"],
      skillslots: [],
      top: "30%",
      left: "25%",
      disabled: true,
    },
    {
      id: "body",
      displayName: "Body",
      backgroundColor: "#B22222",
      children: ["action", "assistance", "source"],
      skillslots: [],
      top: "30%",
      left: "50%",
      disabled: true,
    },
    {
      id: "action",
      displayName: "Action",
      backgroundColor: "#8A2BE2",
      children: ["name", "mind", "body"],
      skillslots: [],
      top: "50%",
      left: "15%",
      disabled: true,
    },
    {
      id: "assistance",
      displayName: "Assistance",
      backgroundColor: "#FF8C00",
      children: ["name", "spirit", "body"],
      skillslots: [],
      top: "50%",
      left: "85%",
      disabled: true,
    },
    {
      id: "assurance",
      displayName: "Assurance",
      backgroundColor: "#228B22",
      children: ["name", "spirit", "mind"],
      skillslots: [],
      top: "50%",
      left: "50%",
      disabled: true,
    },
    {
      id: "name",
      displayName: "Name",
      backgroundColor: "black",
      textColor: "white",
      children: ["action", "assurance", "assistance"],
      skillslots: [],
      top: "75%",
      left: "50%",
      disabled: true,
    },
  ],
};
